<app-header></app-header>
<div class="container otp-container">
  <div class="row justify-content-center text-center pt-4">
    <div class="col-lg-4 col-md-8 col-sm-12 col-xs-12">
      <div class="otp-content">
        <div class="otp-wrap">
          <div class="mb-4">
            <h3>{{ 'otp.title' | translate }}</h3>
          </div>
          <form [formGroup]="otpForm" class="otp-form">
            <div class="form-group" *ngIf="!showOtpTab">
              <div class="mb-4">
                <label for="identityInfo">{{ 'otp.identityInfo' | translate }}</label>
                <div *ngIf="isEditIdInfo">
                  <input
                    type="text"
                    class="form-control text-input"
                    id="identityInfo"
                    formControlName="identityInfo"
                    maxlength="13"
                    autocomplete="off"
                    (input)="identityInfoChange()"
                  />
                  <button
                    class="btn btn-primary btn-block otp-btn mt-4 mb-2"
                    (click)="getMobileNumber()"
                    [disabled]="!identityInfo.value.trim()"
                  >
                    {{ 'otp.confirm' | translate }}
                  </button>
                </div>
                <div *ngIf="!isEditIdInfo">
                  <span>{{ identityInfo.value }}</span>
                  <button class="btn mb-2" *ngIf="!disallowIdEdit" (click)="editIdentityInfo()">
                    <i class="fas fa-fw fa-edit"></i>
                  </button>
                  <div *ngIf="!mobileNumber && errorMessage" class="text-danger" [innerHTML]="errorMessage | translate"></div>
                </div>
              </div>
              <div *ngIf="mobileNumber">
                <p>{{ 'otp.mobileNoLabel' | translate }} {{ mobileNumber | mobileNumberEnc }}</p>
                <button class="btn btn-primary btn-block mb-2" [disabled]="!mobileNumber || disallowIdEdit" (click)="requestOtp()">
                  {{ 'otp.request' | translate }}
                </button>
                <small *ngIf="!errorMessage">{{ 'otp.remark' | translate }}</small>
                <div *ngIf="errorMessage" class="text-danger" [innerHTML]="errorMessage | translate"></div>
              </div>
            </div>
            <div class="form-group" *ngIf="showOtpTab">
              <label for="password">{{ 'otp.passwordLabel' | translate }}</label>
              <input
                type="text"
                pattern="\d*"
                class=" form-control code-input"
                id="otp"
                formControlName="otp"
                maxlength="6"
                autocomplete="off"
                autofocus
                appNumbersOnly
              />
              <div *ngIf="errorMessage" class="text-danger mt-2" [innerHTML]="errorMessage | translate"></div>
              <button class="btn btn-primary btn-block otp-btn mt-4 mb-2" [disabled]="otp.invalid" (click)="confirmOtp()">
                {{ 'otp.confirm' | translate }}
              </button>
              <button class="btn btn-link resend-otp-btn" [disabled]="cooldownSec || disallowIdEdit" (click)="requestOtp()">
                {{ 'otp.resend' | translate }}
                <span *ngIf="cooldownSec"> ({{ cooldownSec }})</span>
              </button>
            </div>
          </form>
        </div>
        <app-footer-azay-logo></app-footer-azay-logo>
      </div>
    </div>
  </div>
</div>
<ng-template #errorModal>
  <div class="modal-body text-center otp-container">
    <div class="row mb-3">
      <div class="col-12">
        {{ 'otp.errors.invalidExceed' | translate }}
      </div>
    </div>
    <div class="row ">
      <div class="col-12">
        <button class="btn btn-primary" (click)="redirectLandingPage()">OK</button>
      </div>
    </div>
  </div>
</ng-template>

<ngx-loading [show]="isLoading"></ngx-loading>
